import React from "react";
import { ProgressBar } from "primereact/progressbar";

// Progress banner for one long-running background job - title, current
// stage and percent, with an indeterminate bar while it hasn't started yet.
// Shared by Compartment Report (compartment_report/JobProgress.js) and
// Platform Report so both show running work the same way.
//   title:   what is running, e.g. "Calculating" / "Generating report - 2026-07-31"
//   stage:   human-readable current step (optional)
//   pct:     0-100, ignored while `queued`
//   queued:  true until the job has actually started
const JobProgress = ({ title, stage, pct, queued = false, style }) => {
  const clampedPct = Math.max(0, Math.min(100, Math.round(pct || 0)));
  return (
    <div className="ex-job-progress" role="status" aria-live="polite" style={style}>
      <div className="ex-job-progress-head">
        <span className="ex-job-progress-title">
          <i className="pi pi-spin pi-spinner ex-job-progress-icon" />
          <strong>{title}</strong>
          {stage && <span className="ex-job-progress-stage"> - {stage}</span>}
        </span>
        {!queued && <span className="ex-job-progress-pct">{clampedPct}%</span>}
      </div>
      {queued ? (
        <ProgressBar mode="indeterminate" className="ex-job-progress-bar" />
      ) : (
        <ProgressBar value={clampedPct} showValue={false} className="ex-job-progress-bar" />
      )}
    </div>
  );
};

export default JobProgress;
